import { useWindowDimensions } from "../../utils/utils";
import Banner from "../../components/layout/banner";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  WhatsApp,
  CallSharp,
  ChevronLeft,
  ChevronRight,
  Close,
  Fullscreen,
  FullscreenExit,
} from "@mui/icons-material";
import { RootState } from "../../app/store";
import { formatMoney } from "../../utils/format";
import Button from "../../components/form/button";
import Modal from "../../components/common/modal";
import Transaction from "../../components/ux/transaction";
import Validation from "../../components/ux/order-validation";
import {
  dismissValidationModal,
  toggleValidationModal,
  toggleTransactionModal,
  dismissTransactionModal,
} from "../../features/payments/paymentsSlice";
import { useQuery } from "@apollo/client";
import { PRODUCT, PRODUCTS_BY_IDS } from "../../api/product/queries";
import { CommentSection } from "./comment";
import CardList from "../../components/card/cardlist";
import Header from "../../components/layout/header";
import UpSell from "../../components/ux/upsell";
import FloatingButton from "../../components/common/floating-button";
import {
  dismissUpSalesModal,
  toggleUpSalesModal,
} from "../../features/products/productsSlice";
import LazyMultilingualAudioPlayer from "../../components/common/lazy-multilingual-audio-player";
import audioTrackWo from "../../assets/tracks/viga-wo.m4a";

interface Props {}

// Helper function to calculate the selling price based on quantity
const getSellingPrice = (basePrice, quantity, priceForTwo, priceForThree) => {
  switch (quantity) {
    case 1:
      return basePrice;
    case 2:
      return priceForTwo;
    case 3:
      return priceForThree;
    default:
      // For quantities greater than 3, apply a general discount or calculate based on base price
      // This logic assumes a 1000 FCFA discount per unit for quantities > 3
      return basePrice * quantity - 1000 * quantity;
  }
};

function VIGA(props: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { productId } = useParams();
  const { data, loading, error } = useQuery(PRODUCT, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      productId: "67e13ac7cb9c3dd784e8cc01", // Updated to VIGA's product ID
    },
  });

  const { width } = useWindowDimensions();
  const [state, setState] = useState({
    loaded: false,
    quantity: 1,
    lineClamp: false,
    showMoreOrLess: "Voir Moins",
    product: {
      _id: "67e13ac7cb9c3dd784e8cc01",
      shop: {
        _id: "63d12a74fe7b1e352d970f18",
      },
      name: "VIGA 60 MINUTES",
      price: 6000,
      previousPrice: 8000,
      price_for_two: 11000,
      price_for_three: 15000,
      selling_for: 6000, // Initial selling price for quantity 1
      uri: "https://vertus-organic.web.app/viga",
    },
  });

  const inputRef = useRef<HTMLInputElement>(null);
  const slideIntervalRef = useRef<NodeJS.Timeout | null>(null);

  const isValidationModalOpen = useAppSelector(
    (state: RootState) => state.payments.isValidationModalOpen
  );

  const isTransactionModalOpen = useAppSelector(
    (state: RootState) => state.payments.isTransactionModalOpen
  );

  const upSalesModalIsOpen = useAppSelector(
    (state: RootState) => state.products.product.upSalesModalIsOpen
  );

  const images = [
    "https://newhackerway.blob.core.windows.net/images/Viga/53.png?sp=r&st=2025-07-07T20:25:45Z&se=2029-07-08T04:25:45Z&sv=2024-11-04&sr=b&sig=s%2FVeJWyEsqQpDf42gbbYon%2BcaF2FD3fSzzProSowMKU%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/59.png?sp=r&st=2025-07-07T20:46:44Z&se=2029-07-08T04:46:44Z&sv=2024-11-04&sr=b&sig=IGD%2BWnAqYG1KaRneUT6e0xTvWUlG7Uj%2BzhpYyn0O4xA%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/51%20-%20Bis.png?sp=r&st=2025-08-15T15:18:31Z&se=2029-08-15T23:33:31Z&sv=2024-11-04&sr=b&sig=YcN7iLSKtMr36Ef7ev6AundEVgWHyFWlMxJ4UJ5XbtY%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/54.png?sp=r&st=2025-07-07T20:29:36Z&se=2029-07-08T04:29:36Z&sv=2024-11-04&sr=b&sig=PLTraAxjZGVKsPt7WXylKUY1CVGAf%2F8mBxHUzq%2Bz3S0%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/55.png?sp=r&st=2025-07-07T20:30:06Z&se=2029-07-08T04:30:06Z&sv=2024-11-04&sr=b&sig=0X8PIVPxGyUqT5IliuIKVtWgdQmoDqM4w%2BiVHXoGtjc%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/57.png?sp=r&st=2025-07-07T20:57:36Z&se=2029-07-08T04:57:36Z&sv=2024-11-04&sr=b&sig=toZuUKjYEXZ1wf%2BsaKKW8W5eSRQlgdt393owE4fTvOg%3D",
    "https://newhackerway.blob.core.windows.net/images/Viga/49%20-%20Bis.png?sp=r&st=2025-08-15T15:18:56Z&se=2029-08-15T23:33:56Z&sv=2024-11-04&sr=b&sig=X%2FQ4wN1je2TZ2gZEdVw%2BOSC0ZPI10f03uVcPHVLHPhc%3D",
    "https://newhackerway.blob.core.windows.net/images/Big%20Man/44.png?sp=r&st=2025-07-05T01:05:19Z&se=2029-07-05T09:05:19Z&sv=2024-11-04&sr=b&sig=q660r%2FiaakFaOXn1iJ1QmjSAr%2BvF5QukAxZ7TmUQ9Gw%3D",
    "https://newhackerway.blob.core.windows.net/images/Big%20Man/46.png?sp=r&st=2025-07-05T01:05:44Z&se=2029-07-05T09:05:44Z&sv=2024-11-04&sr=b&sig=O139SEVHC3RIJTSXEz%2BPULaX%2BNaN%2FbSzWDwVZRRkBms%3D",
  ];

  const handleOnBlur = () => {
    if (inputRef.current) {
      if (inputRef.current.value === "") {
        inputRef.current.style.fontFamily = "Leckerli One";
      }
    }
  };

  const handleOnFocus = () => {
    if (inputRef.current) {
      if (inputRef.current.value === "") {
        inputRef.current.style.fontFamily = "Lato";
      }
    }
  };

  // Centralized function to update quantity and selling price
  const updateQuantityAndPrice = (newQuantity) => {
    setState((prevState) => {
      // Ensure quantity doesn't go below 1
      const effectiveQuantity = Math.max(1, newQuantity);

      const newSellingFor = getSellingPrice(
        prevState.product.price,
        effectiveQuantity,
        prevState.product.price_for_two,
        prevState.product.price_for_three
      );

      return {
        ...prevState,
        quantity: effectiveQuantity,
        product: {
          ...prevState.product,
          selling_for: newSellingFor,
        },
      };
    });
  };

  const handleSetQuantity = (quantity) => {
    updateQuantityAndPrice(quantity);
  };

  const handleDecreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity - 1);
  };

  const handleIncreaseQuantity = () => {
    updateQuantityAndPrice(state.quantity + 1);
  };

  const handleSubmit = (e: any) => {
    dispatch(toggleValidationModal());
  };

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const slideRef = useRef<HTMLDivElement>(null);
  const touchStartX = useRef<number>(0);
  const touchEndX = useRef<number>(0);

  const handleChevronLeft = useCallback(() => {
    const size = images?.length;
    setCurrentIndex((prevIndex) => (prevIndex + size - 1) % size);
  }, [images?.length]);

  const handleChevronRight = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
  }, [images?.length]);

  const pauseSlider = useCallback(() => {
    if (slideIntervalRef.current) {
      clearInterval(slideIntervalRef.current);
      slideIntervalRef.current = null;
    }
  }, []);

  const startSlider = useCallback(() => {
    pauseSlider();
    slideIntervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
    }, 5000);
  }, [images?.length, pauseSlider]);

  // Touch handlers for mobile swipe
  const handleTouchStart = useCallback((e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  }, []);

  const handleTouchMove = useCallback((e: React.TouchEvent) => {
    touchEndX.current = e.touches[0].clientX;
  }, []);

  const handleTouchEnd = useCallback(() => {
    const swipeThreshold = 50;
    const diff = touchStartX.current - touchEndX.current;

    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        handleChevronRight();
      } else {
        handleChevronLeft();
      }
    }
  }, [handleChevronLeft, handleChevronRight]);

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "ArrowLeft") {
        handleChevronLeft();
      } else if (e.key === "ArrowRight") {
        handleChevronRight();
      } else if (e.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    },
    [handleChevronLeft, handleChevronRight, isFullscreen]
  );

  useEffect(() => {
    startSlider();

    if (slideRef.current) {
      slideRef.current.addEventListener("mouseenter", pauseSlider);
      slideRef.current.addEventListener("mouseleave", startSlider);
    }

    // Add keyboard event listener
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      pauseSlider();
      if (slideRef.current) {
        slideRef.current.removeEventListener("mouseenter", pauseSlider);
        slideRef.current.removeEventListener("mouseleave", startSlider);
      }
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [startSlider, pauseSlider, handleKeyDown]);

  const toggleLineClamp = () => {
    setState((prevState) => ({
      ...prevState,
      lineClamp: !prevState.lineClamp,
      showMoreOrLess: !prevState.lineClamp ? "Voir Plus" : "Voir Moins",
    }));
  };

  const toggleFullscreen = useCallback(() => {
    setIsFullscreen((prev) => !prev);
  }, []);

  const ImageGridItem = () => {
    return (
      <div className="relative">
        <img
          onLoad={() => {
            setState((prevState) => ({
              ...prevState,
              loaded: true,
            }));
          }}
          src={images[currentIndex]}
          loading="lazy"
          alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
            images?.length
          }`}
          style={{
            width: "100%",
            maxHeight: "80vh",
            minWidth: "0",
            objectFit: "cover",
          }}
          role="img"
          aria-label={`Image ${currentIndex + 1} de ${
            images?.length
          } du produit ${state?.product?.name}`}
          onContextMenu={(e) => e.preventDefault()}
        />
        <button
          onClick={toggleFullscreen}
          className="absolute bottom-2 right-2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 transition-all"
          aria-label="Afficher en plein écran"
          title="Afficher en plein écran (Cliquer sur l'image)"
        >
          <Fullscreen />
        </button>
      </div>
    );
  };

  // Fullscreen Modal Component
  const FullscreenModal = () => {
    if (!isFullscreen) return null;

    return (
      <div
        className="fixed inset-0 z-[9999] bg-black bg-opacity-95 flex items-center justify-center"
        onClick={toggleFullscreen}
        role="dialog"
        aria-modal="true"
        aria-label="Visualisation en plein écran"
      >
        <div className="relative w-full h-full flex items-center justify-center">
          {/* Close Button */}
          <button
            onClick={toggleFullscreen}
            className="absolute top-4 right-4 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-2 z-10 transition-all"
            aria-label="Fermer le plein écran (Échap)"
            title="Fermer (Échap)"
          >
            <Close fontSize="large" onClick={toggleFullscreen} />
          </button>

          {/* Navigation Buttons */}
          {images?.length > 1 && (
            <>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronLeft();
                }}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image précédente"
                title="Image précédente (Flèche gauche)"
              >
                <ChevronLeft fontSize="large" />
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleChevronRight();
                }}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-75 hover:bg-opacity-100 rounded-full p-3 z-10 transition-all"
                aria-label="Image suivante"
                title="Image suivante (Flèche droite)"
              >
                <ChevronRight fontSize="large" />
              </button>
            </>
          )}

          {/* Main Image */}
          <img
            src={images[currentIndex]}
            alt={`${state?.product?.name} - Image ${currentIndex + 1} sur ${
              images?.length
            }`}
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
            onContextMenu={(e) => e.preventDefault()}
          />

          {/* Image Counter */}
          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-white bg-opacity-75 px-4 py-2 rounded-full">
            <span className="font-semibold">
              {currentIndex + 1} / {images?.length}
            </span>
          </div>

          {/* Thumbnails in fullscreen */}
          {images?.length > 1 && (
            <div className="absolute bottom-20 left-1/2 transform -translate-x-1/2 flex gap-1 overflow-x-auto min-w-[70vw] max-w-[90vw] scrollbar-hide">
              {images.map((img, i) => (
                <button
                  key={i}
                  onClick={(e) => {
                    e.stopPropagation();
                    setCurrentIndex(i);
                  }}
                  className={`flex-shrink-0 border-2 rounded transition-all ${
                    currentIndex === i
                      ? "border-white ring-2 ring-white"
                      : "border-transparent opacity-60 hover:opacity-100"
                  }`}
                >
                  <img
                    src={img}
                    alt={`Miniature ${i + 1}`}
                    className="w-16 h-16 object-cover rounded"
                    onContextMenu={(e) => e.preventDefault()}
                  />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  };

  const {
    data: products,
    fetchMore,
    networkStatus,
    refetch,
  } = useQuery(PRODUCTS_BY_IDS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
    errorPolicy: "all",
    variables: {
      first: 50,
      productIds: [
        "6429962817f015be43b52b1b",
        "6429948d17f015be43b52af1",
        "689688cd74c5a7be0001929e",
        "6a71f32b3684d4971acfb615",
      ],
    },
  });

  return (
    <>
      {/* Fullscreen Image Viewer */}
      <FullscreenModal />

      <Modal
        modalIsOpen={upSalesModalIsOpen}
        className="w-4/5 md:w-3/5"
        dismissModal={() => dispatch(dismissUpSalesModal())}
        handleModal={() => dispatch(toggleUpSalesModal())}
        content={<UpSell products={products?.productsByIds?.page?.edges} />}
      />
      <Modal
        modalIsOpen={isValidationModalOpen}
        className="w-4/5 md:w-3/12"
        dismissModal={() => dispatch(dismissValidationModal())}
        content={
          <Validation
            pixelId="1290489315765991"
            handleDismiss={() => dispatch(dismissValidationModal())}
            item={{ ...state.product, quantity: state.quantity }}
          />
        }
      />
      {/* The Grid */}
      <div
        className="mx-auto grid min-h-screen"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "5em auto",
        }}
      >
        {/* Header */}
        {/* Header Hack */}
        <div className="header"></div>
        <div className="fixed top-0 left-0 right-0 z-50 bg-white w-full">
          <Banner className="bg-djeliba" />
          <Header />
        </div>
        {/* Content */}
        <div
          style={{
            gridColumn: "1 / -1",
          }}
        >
          <div className="flex flex-col my-5 md:flex-row justify-around items-start">
            <div className="w-full md:w-1/3 border relative">
              <div
                ref={slideRef}
                className="w-full select-none relative"
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                role="region"
                aria-label="Carousel d'images du produit"
                aria-live="polite"
              >
                <div className="w-full flex-row flex justify-evenly items-center">
                  <figure className="md:h-full grow md:m-2.5">
                    {ImageGridItem()}
                  </figure>
                </div>
                {images?.length > 1 && (
                  <>
                    <div
                      className="absolute md:my-0 my-4 flex w-full md:flex-col md:w-1/6 md:h-full md:overflow-y-auto overflow-scroll scrollbar-hide md:-left-16 md:-top-1 md:px-3 justify-start items-center bg-transparent"
                      role="tablist"
                      aria-label="Miniatures des images"
                    >
                      {images.map((item, i) => (
                        <button
                          key={i}
                          className={`border rounded md:my-1 hover:border-2 md:w-full min-w-14 mx-1 transition-all ${
                            currentIndex === i
                              ? "border-djeliba border-2 ring-2 ring-djeliba"
                              : "border-djeliba"
                          }`}
                          onClick={() => setCurrentIndex(i)}
                          onMouseEnter={() => setCurrentIndex(i)}
                          role="tab"
                          aria-selected={currentIndex === i}
                          aria-label={`Afficher image ${i + 1}`}
                          title={`Image ${i + 1}`}
                        >
                          <img
                            src={images[i]}
                            alt={`Miniature ${i + 1}`}
                            loading="lazy"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              minWidth: "0",
                              objectFit: "cover",
                            }}
                            onContextMenu={(e) => e.preventDefault()}
                          />
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
              <div className="w-full px-1 flex justify-between items-center">
                <div className="flex max-w-min">
                  <a
                    className="text-green-500 top-0 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`tel:${221773808340}`}
                  >
                    <CallSharp
                      className="border rounded-md p-1 text-blue-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                  <a
                    className="text-green-500 top-11 right-1 m-1 p-0.5 rounded absolute"
                    target="_blank"
                    rel="noreferrer"
                    href={`https://api.whatsapp.com/send?phone=${221773808340}&text=${encodeURIComponent(
                      "Je souhaite commander l'article : " +
                        state?.product?.name +
                        "\n\nLien : " +
                        state?.product?.uri
                    )}`}
                  >
                    <WhatsApp
                      className="border rounded-md text-green-500 bg-white"
                      fontSize="large"
                    />
                  </a>
                </div>
                {images?.length > 1 && (
                  <div
                    className="flex w-full h-5 justify-center items-center"
                    role="group"
                    aria-label="Indicateurs de progression du carousel"
                  >
                    {images?.map((item, i) => (
                      <button
                        key={i}
                        onClick={() => setCurrentIndex(i)}
                        className={
                          currentIndex === i
                            ? "bg-black h-1.5 w-1.5 rounded-full ml-1 cursor-pointer hover:scale-150 transition-transform"
                            : "bg-slate-400 h-1 w-1.5 rounded-sm ml-1 cursor-pointer hover:bg-slate-600 transition-colors"
                        }
                        aria-label={`Aller à l'image ${i + 1}`}
                        aria-current={currentIndex === i ? "true" : "false"}
                        title={`Image ${i + 1}`}
                      ></button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="w-full mt-14 md:mt-0 md:w-1/2 h-full md:border hover:border-0">
              <div className="mx-2 my-3">
                <LazyMultilingualAudioPlayer
                  productId={state?.product?._id}
                  tracks={{
                    wo: audioTrackWo,
                  }}
                  languageLabels={{
                    wo: "Wolof",
                    pl: "Pulaar",
                    fr: "Français",
                  }}
                />
              </div>
              <div className="flex justify-around md:justify-between items-center mb-2">
                <div id="product-name-container">
                  <div className="m-2">
                    <span className="font-bold text-lg md:text-3xl">
                      {state?.product?.name}
                    </span>
                  </div>
                  <div className="m-2">
                    <span className="font-bold text-yellow-500 md:text-xl">
                      Livraison gratuite
                    </span>
                  </div>
                  <div className="m-2 my-3">
                    <div
                      className={
                        state.quantity === 1
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-red-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(1)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Viga/53.png?sp=r&st=2025-07-07T20:25:45Z&se=2029-07-08T04:25:45Z&sv=2024-11-04&sr=b&sig=s%2FVeJWyEsqQpDf42gbbYon%2BcaF2FD3fSzzProSowMKU%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥
                          <span>1</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-red-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice - state.product.price
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 2
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-red-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(2)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Viga/53.png?sp=r&st=2025-07-07T20:25:45Z&se=2029-07-08T04:25:45Z&sv=2024-11-04&sr=b&sig=s%2FVeJWyEsqQpDf42gbbYon%2BcaF2FD3fSzzProSowMKU%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥
                          <span>2</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(state?.product?.price_for_two)}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-red-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 2}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 2 -
                                state.product.price_for_two
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className={
                        state.quantity === 3
                          ? "flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300 border-2 border-red-500"
                          : `flex justify-between items-center my-2 bg-djeliba p-1 rounded-md hover:cursor-pointer hover:shadow-2xl hover:transition-all ease-linear duration-300`
                      }
                      onClick={() => handleSetQuantity(3)}
                    >
                      <div className="h-12 w-12 mr-1">
                        <img
                          className="w-full rounded-md"
                          src="https://newhackerway.blob.core.windows.net/images/Viga/53.png?sp=r&st=2025-07-07T20:25:45Z&se=2029-07-08T04:25:45Z&sv=2024-11-04&sr=b&sig=s%2FVeJWyEsqQpDf42gbbYon%2BcaF2FD3fSzzProSowMKU%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                      <div className="flex flex-col w-full items-end">
                        <div className="flex w-full justify-around">
                          🔥🔥🔥
                          <span>3</span>
                          <span>--&gt;</span>
                          <span className="font-thin">
                            {formatMoney.format(
                              state?.product?.price_for_three
                            )}
                          </span>
                        </div>
                        <div className="flex w-full justify-center">
                          <span className="flex justify-around w-full text-sm text-red-500">
                            <span className="line-through text-black">
                              {state.product.previousPrice * 3}
                            </span>{" "}
                            Economisez{" "}
                            {formatMoney.format(
                              state.product.previousPrice * 3 -
                                state.product.price_for_three
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex-col justify-evenly items-center">
                  <div className="flex justify-center items-center">
                    <span
                      onClick={handleDecreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-black bg-djeliba text-xl"
                    >
                      -
                    </span>
                    <span className="font-bold rounded-sm px-1 mx-1 bg-black text-white text-lg">
                      {state.quantity}
                    </span>
                    <span
                      onClick={handleIncreaseQuantity}
                      className="font-bold rounded-md px-2 mx-1 hover:cursor-pointer border-2 hover:border-red-500 bg-djeliba text-xl"
                    >
                      +
                    </span>
                  </div>
                  <div className="px-2">
                    <Button
                      id="commander-button"
                      title="Commander"
                      isWaiting={false}
                      handleOnClick={(e) => handleSubmit(e)}
                      disabled={false}
                      className="hover:shadow-2xl cursor-pointer hover:transition-all ease-linear duration-300"
                    />
                  </div>
                </div>
              </div>
              <div className="mx-2">
                {state.lineClamp ? (
                  <p
                    className="border-none w-full outline-none text-sm px-2 py-1 rounded-md ml-1"
                    style={{
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 1,
                      overflow: "hidden",
                    }}
                    onClick={toggleLineClamp}
                  >
                    VIGA 60 MINUTES – Contrôle et Endurance pour des Moments
                    Plus Longs; Découvrez VIGA 60 MINUTES, la solution idéale
                    pour les hommes qui souhaitent reprendre le contrôle de leur
                    éjaculation et prolonger la durée des rapports intimes.
                    Grâce à sa formule à base de lidocaïne, un anesthésiant
                    local doux, Viga agit directement sur la sensibilité du
                    pénis, permettant de retarder l’éjaculation sans diminuer le
                    plaisir.
                  </p>
                ) : (
                  <div className="flex-row" onClick={toggleLineClamp}>
                    <p className="">
                      VIGA 60 MINUTES – Contrôle et Endurance pour des Moments
                      Plus Longs; Découvrez VIGA 60 MINUTES, la solution idéale
                      pour les hommes qui souhaitent reprendre le contrôle de
                      leur éjaculation et prolonger la durée des rapports
                      intimes. Grâce à sa formule à base de lidocaïne, un
                      anesthésiant local doux, Viga agit directement sur la
                      sensibilité du pénis, permettant de retarder l’éjaculation
                      sans diminuer le plaisir.
                    </p>
                    <div className="m-1">
                      <h2 className="text-lg">
                        🎯 À qui est destiné VIGA 60 MINUTES ?
                      </h2>
                      VIGA 60 MINUTES s’adresse aux hommes qui souhaitent
                      améliorer leurs performances sexuelles et profiter
                      pleinement de leurs moments intimes. Il est
                      particulièrement recommandé pour :
                      <ul className="list-disc ml-6">
                        <li>Les hommes souffrant d’éjaculation précoce</li>
                        <li>
                          Ceux qui veulent prolonger la durée de leurs rapports
                        </li>
                        <li>
                          Les hommes cherchant à mieux contrôler leur excitation
                        </li>
                        <li>
                          Ceux qui souhaitent gagner en confiance et en
                          assurance au lit
                        </li>
                        <li>
                          Les partenaires désireux d’augmenter la satisfaction
                          mutuelle
                        </li>
                        <li>
                          Les hommes qui recherchent une solution discrète et
                          rapide d’action
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Attote/6.png?sp=r&st=2025-08-14T15:33:18Z&se=2029-08-14T23:48:18Z&sv=2024-11-04&sr=b&sig=VRKJ1QXqBMSm7POjQZknUjGxqiV2DWuZpxG7owp6IGI%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        💪 Les avantages de VIGA 60 MINUTES :
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>Aide à retarder l’éjaculation naturellement</li>
                        <li>
                          Permet des rapports plus longs et plus satisfaisants
                        </li>
                        <li>Facile à utiliser et discret</li>
                        <li>N’altère pas la sensation globale du plaisir</li>
                        <li>Agit rapidement – quelques minutes suffisent</li>
                        Conçu pour les hommes souffrant d’éjaculation précoce,
                        ou simplement ceux qui souhaitent améliorer leur
                        endurance, VIGA 60 MINUTES vous offre plus de confiance
                        et de maîtrise pendant l’acte.
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Big%20Man/20250707_100528_0003.png?sp=r&st=2025-07-15T16:46:14Z&se=2029-07-16T01:01:14Z&sv=2024-11-04&sr=b&sig=h9a4za4EI81rqX9GgAKyhznX9Q%2FiZqIG6jVk4OjzaQE%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">📌 Mode d’utilisation :</h2>
                      <ul className="list-disc ml-6">
                        <li>
                          Vaporiser 2 à 3 pulvérisations sur le gland du pénis,
                          20 à 30 minutes avant le rapport sexuel.
                        </li>
                        <li>
                          Laisser agir, puis essuyer légèrement l’excès avant la
                          pénétration pour éviter tout transfert au partenaire.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          src="https://newhackerway.blob.core.windows.net/images/Big%20Man/20250707_100528_0002.png?sp=r&st=2025-07-07T19:48:47Z&se=2029-07-08T03:48:47Z&sv=2024-11-04&sr=b&sig=LW3ws0KB4Dlm6wVd0ppslBbwRpVNoMCKRUpYsxnlJNM%3D"
                          alt=""
                          onContextMenu={(e) => e.preventDefault()}
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="m-1">
                      <h2 className="text-lg">
                        🌿 Pratique – Rapide – Efficace
                      </h2>
                      <ul className="list-disc ml-6">
                        <li>
                          VIGA 60 MINUTES est un allié discret et efficace que
                          tout homme devrait avoir sous la main pour assurer des
                          performances à la hauteur, sans stress ni complexe.
                        </li>
                        <li>
                          VIGA 60 MINUTES – Parce que la performance, c’est
                          aussi la maîtrise du temps.
                        </li>
                      </ul>
                      <div className="flex md:w-1/2 p-2">
                        <img
                          onContextMenu={(e) => e.preventDefault()}
                          src="https://newhackerway.blob.core.windows.net/images/Attote/20250707_100528_0000.png?sp=r&st=2025-07-07T18:07:06Z&se=2029-07-08T02:07:06Z&sv=2024-11-04&sr=b&sig=jk4G5hwfeYmLn4Hpwwdd4053FSMshmeC0NE3ExY1G%2Fg%3D"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                )}

                <span
                  className="text-sm font-thin text-gray-400 cursor-pointer"
                  onClick={toggleLineClamp}
                >
                  {state.showMoreOrLess}
                </span>
              </div>

              <div className="flex-col w-full mt-2 md:mt-0 h-full overflow-hidden">
                {/* Integrate the CommentSection component */}
                <CommentSection />
              </div>
            </div>
          </div>
        </div>

        {/* Recommendation */}
        <div
          className="p-0 my-2"
          style={{
            gridColumn: "1 / -1",
          }}
        >
          {/* <>
            <div className="flex justify-start md:justify-center items-center m-2 p-1">
              <span className="font-bold text-xl">
                D'autres produits de{" "}
                <span className="text-yellow-500">{data?.product?.shop?.name}</span>
              </span>
            </div>
            <Slider
              images={data?.productsByShop.page.edges?.map(
                (item) => item?.node?.images[0]?.lg
              )}
            />
          </> */}
        </div>

        {/* Footer */}

        {/* Bouton flottant pour remonter en haut */}
        <FloatingButton targetSelector="#product-name-container" />
      </div>
    </>
  );
}

export default VIGA;
